import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringify'
})
export class StringifyPipe implements PipeTransform {

  transform(data: any, pretty: boolean = false): unknown {
    return pretty ? JSON.stringify(data, null, 2) : JSON.stringify(data);
  }

}
